import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../components/Button';
import Title from '../../components/Title';
import Layout from '../../layouts';

function AwaitQuestionsPage() {
  const history = useHistory();

  return (
    <Layout>
      <Title>READY to REACT?</Title>

      <p className="text-2xl lg:text-3xl text-center my-4 px-8 md:px-20">
        <b>5</b> Weekly Players with <b>4,000+</b> points will win big prizes.
      </p>

      <Button title="PLAY" handleClick={handleNavigation} />
    </Layout>
  );

  function handleNavigation() {
    history.push(`/questions`);
  }
}

export default AwaitQuestionsPage;
